import { Breakpoints, BreakpointWrapper, CTA, Text, TokenTextColor } from '@volkswagen-onehub/components-core';
import React, { ReactElement } from 'react';
import styled from 'styled-components';
import { StepsNavigationViewProps } from './StepsNavigationViewProps';
import { Titles } from '../Tiltes';
import { BrandTitlesVw } from '../brand-titles/BrandTitlesVw';
import { Checkmark } from '@volkswagen-onehub/icons-core';
import { TextAppearance } from '@volkswagen-onehub/tokens';

const StyledTitle = styled(Text)`
  text-align: center;
  margin-bottom: ${(props) => props.theme.size.dynamic0050};
`;

const StyledLayout = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(70px, 1fr));
  grid-auto-rows: auto;
  gap: 5px;
  justify-content: stretch;
  justify-items: center;

  @media (max-width: ${Breakpoints.b560}px) {
    grid-template-columns: repeat(auto-fit, minmax(60px, 1fr));
  }
`;

const StyledCTA = styled(CTA)`
  & span {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-decoration: none;

    .icon-wrapper {
      height: 32px;
    }
  }
`;

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export function StepsNavigationView({ steps, currentStep }: StepsNavigationViewProps): ReactElement {
  return (
    <StyledContainer>
      <StyledTitle appearance={TextAppearance.headline400}>{BrandTitlesVw[currentStep]}</StyledTitle>
      <StyledLayout>
        {steps.map((step) => (
          <StyledCTA tag="a" emphasis="tertiary" onClick={step.onNavigateToStep} disabled={!step.navigationEnabled} key={step.step}>
            <span className="icon-wrapper">
              {currentStep > step.step ? (
                <Checkmark />
              ) : (
                <Text
                  bold={currentStep === step.step}
                  color={currentStep === step.step ? TokenTextColor.primary : TokenTextColor.secondary}>
                  {step.step}
                </Text>
              )}
            </span>
            <span className="label-wrapper">
              <BreakpointWrapper max={Breakpoints.b960}>
                <Text
                  appearance={TextAppearance.label100}
                  bold={currentStep === step.step}
                  color={currentStep === step.step ? TokenTextColor.primary : TokenTextColor.secondary}>
                  {Titles[step.step]}
                </Text>
              </BreakpointWrapper>
              <BreakpointWrapper min={Breakpoints.b960}>
                <Text
                  appearance={TextAppearance.copy100}
                  bold={currentStep === step.step}
                  color={currentStep === step.step ? TokenTextColor.primary : TokenTextColor.secondary}>
                  {Titles[step.step]}
                </Text>
              </BreakpointWrapper>
            </span>
          </StyledCTA>
        ))}
      </StyledLayout>
    </StyledContainer>
  );
}
